<ng-container *ngIf="flexible; else PeriodSelector">
  <div class="checkbox-enhanced">
    <input
      type="checkbox"
      [ngModel]="usePeriodDate$.value"
      (ngModelChange)="usePeriodDate$.next($event)"
    />
    <label> Use period {{ useEndDate ? 'end' : 'start' }} date </label>
  </div>

  <app-date-input
    *ngIf="!usePeriodDate$.value; else PeriodSelector"
    appValidationContext
    [minDate]="minDate"
    [disabled]="isLoading || isDisabled"
    [(ngModel)]="value"
    (ngModelChange)="onChange()"
    (blur)="onTouched()"
  >
    <ng-content></ng-content>
    <div *invalidMessageFor="'required'">Date is required</div>
    <div *invalidMessageFor="'minDate' as error">
      Date must be on or after {{ error.minDate | aadate }}
    </div>
  </app-date-input>
</ng-container>

<ng-template #PeriodSelector>
  <select
    class="form-select"
    [class.is-invalid]="control.invalid && control.touched"
    [class.is-valid]="control.valid && control.touched"
    [disabled]="isLoading || isDisabled"
    [(ngModel)]="value"
    (change)="onChange()"
    (blur)="onTouched()"
  >
    <ng-container *ngIf="allowEmpty; else Select">
      <option value="">First Use</option>
    </ng-container>
    <ng-template #Select>
      <option value="">Select&hellip;</option>
      <option
        *ngIf="hasEarlierPeriodsAvailable"
        [value]="GetMorePeriods.GetEarlierPeriods"
      >
        Get earlier dates&hellip;
      </option>
    </ng-template>
    <ng-container *ngFor="let fyGroup of filteredCalendarDates$ | async">
      <optgroup *ngIf="fyGroup.fy as fy" [label]="fy | aafinyear">
        <ng-container *ngTemplateOutlet="Options"></ng-container>
      </optgroup>
      <ng-container *ngIf="!fyGroup.fy">
        <ng-container *ngTemplateOutlet="Options"></ng-container>
      </ng-container>

      <ng-template #Options>
        <ng-container *ngFor="let date of fyGroup.periods">
          <option [ngValue]="date">{{ date | aadate }}</option>
        </ng-container>
      </ng-template>
    </ng-container>
    <option [value]="GetMorePeriods.GetLaterPeriods">
      Get later dates&hellip;
    </option>
  </select>
  <ng-content></ng-content>
</ng-template>
